import { MappingValue } from 'src/entities/import';

export const MAX_ADDRESS_MAPPING_ROWS = 3;

export const addressMappingSelections = (value: MappingValue): string[] => {
  if (Array.isArray(value)) return value.filter(Boolean).slice(0, MAX_ADDRESS_MAPPING_ROWS);
  return value ? [value] : [];
};

export const buildAddressMappingRows = (value: MappingValue, visibleRowCount: number): Array<string | null> => {
  const selections = addressMappingSelections(value);
  const rowCount = Math.min(
    MAX_ADDRESS_MAPPING_ROWS,
    Math.max(visibleRowCount, selections.length, 1)
  );

  return Array.from({ length: rowCount }, (_, index) => selections[index] || null);
};

export const setAddressMappingSelection = (
  value: MappingValue,
  index: number,
  nextValue: string | null
): string[] => {
  const rows = buildAddressMappingRows(value, index + 1);
  rows[index] = nextValue;
  return rows.filter((row): row is string => !!row).slice(0, MAX_ADDRESS_MAPPING_ROWS);
};

export const removeAddressMappingSelection = (value: MappingValue, index: number): string[] => {
  const selections = addressMappingSelections(value);
  selections.splice(index, 1);
  return selections.slice(0, MAX_ADDRESS_MAPPING_ROWS);
};

export const canAddAddressMappingRow = (visibleRowCount: number): boolean => visibleRowCount < MAX_ADDRESS_MAPPING_ROWS;

export const nextAddressMappingRowCountAfterRemoval = (
  visibleRowCount: number,
  remainingSelectionCount: number
): number => Math.max(Math.min(visibleRowCount - 1, MAX_ADDRESS_MAPPING_ROWS), remainingSelectionCount, 1);
